export const enablePopFor = [
  { value: 'ALL_MAIL', displayValue: 'All Mail' },
  { value: 'MAIL_FROM_NOW_ON', displayValue: 'Mail from now on' },
];

export const actionPopOptions = [
  { value: 'ARCHIVE', displayValue: `Archive Gmail's copy` },
  { value: 'KEEP', displayValue: `Keep Gmail's copy in the inbox` },
  { value: 'MARK_READ', displayValue: `Mark Gmail's copy as read` },
  { value: 'DELETE', displayValue: `Delete Gmail's copy` },
];
